<template lang="pug">
  .fpui-icon-select.col-xs-12
    multiselect(
      v-model="model"
      :placeholder="selected || placeholder",
      :options="options.fontAwesome",
      :custom-label="customLabel",
      :show-labels="false"
      @select="selectedValue"
    )
      template(slot="option", slot-scope="props")
        i(:class="props.option")
          span.option__title {{ props.option }}
</template>

<script>
import { FaIconsArray } from './FpuiFontIcons'

export default {
  props: [ 'value', 'placeholder' ],
  data () {
    return {
      options:
        { fontAwesome: FaIconsArray },
      selected: ''

    }
  },
  computed: {
    model: {
      get () { return this.value },
      set (val) { return this.$emit('input', val) }
    }
  },
  methods: {
    customLabel (selected) {
      return `${selected}`
    },
    selectedValue(val) {
      this.selected = val;
      this.$emit('input', val)
    }
  }
}
</script>
